import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  padding: 1rem 2.5rem;
  font-size: 1rem;
  text-decoration: none;
  border-radius: 50px;
  transition: var(--transition-smooth);
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  cursor: pointer;
  border: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
    z-index: -1;
  }

  &:hover::before {
    width: 300px;
    height: 300px;
  }

  ${props => props.$variant === 'primary' && `
    background: var(--primary-color);
    color: white;
    border: 2px solid var(--primary-color);
    box-shadow: var(--shadow-sm);

    &:hover {
      background: var(--primary-hover);
      transform: translateY(-3px);
      box-shadow: var(--shadow-primary);
      border-color: var(--primary-hover);
    }
  `}

  ${props => props.$variant === 'secondary' && `
    background: transparent;
    color: white;
    border: 2px solid white;

    &:hover {
      background: white;
      color: var(--dark-bg);
      transform: translateY(-3px);
      box-shadow: var(--shadow-md);
    }
  `}
`;

const StyledButton = styled.button`
  padding: 1rem 2.5rem;
  font-size: 1rem;
  text-decoration: none;
  border-radius: 50px;
  transition: var(--transition-smooth);
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  background: var(--primary-color);
  color: white;
  border: 2px solid var(--primary-color);
  box-shadow: var(--shadow-sm);

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
    z-index: -1;
  }

  &:hover::before {
    width: 300px;
    height: 300px;
  }

  &:hover {
    background: var(--primary-hover);
    transform: translateY(-3px);
    box-shadow: var(--shadow-primary);
    border-color: var(--primary-hover);
  }

  ${props => props.$variant === 'secondary' && `
    background: transparent;
    color: white;
    border: 2px solid white;

    &:hover {
      background: white;
      color: var(--dark-bg);
    }
  `}
`;

const Button = ({ children, to, onClick, variant = 'primary', ...props }) => {
  if (to) {
    return (
      <StyledLink to={to} $variant={variant} {...props}>
        {children}
      </StyledLink>
    );
  }
  
  return (
    <StyledButton onClick={onClick} $variant={variant} {...props}>
      {children}
    </StyledButton>
  );
};

export default Button;
